import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableTab from "../components/tabs/table-tab";
import { PRESETS_CONTROLLERS } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Category } from "../models/Category";
import columns from '../models/ColumnDefinitions/ControllerPresetsColumns';
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/HardwarePresetSearch';
import SiteSearch from "../models/search/SiteSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deletePreset, getControllerPreset } from "../services/hardwarePresetService";
import { getSiteNamesWithPagination } from "../services/siteService";

interface Props {
    setBusy: (isBusy: boolean) => void,
    categories: Category[],
    setCategories: (category: Category[]) => void
}

const ControllerPresetsTab: FC<Props> = ({ setBusy, categories, setCategories }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.allController);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const itemPath = '/access-control/hardware/controller-preset/';
    const CONTROLLER_PRESET_TAB_POSITION = 1;

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, [])

    const onDelete = (id: string) : Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deletePreset(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        const newCatergories: Category[] = categories.map((category) => {
                            return category.id === CONTROLLER_PRESET_TAB_POSITION ? { ...category, count: (category?.count ?? 1) - 1 } : category;
                        })
                        setCategories(newCatergories);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))

    const initialiseUserPreferences = (setDetails: (userLoginId, PRESETS_CONTROLLERS) => void) => {
        setDetails(userLoginId, PRESETS_CONTROLLERS);
    }
    // <-- end context

    return <TableContextProvider
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        dataMethod={getControllerPreset}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        deleteMethod={onDelete}
        lookup={lookup}
        customDelete={{ fieldName: "isDefault", comparisonValue: false }}>
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath} 
            cyName="controllerPresets"/>
    </TableContextProvider>
};

export default ControllerPresetsTab;
